<app-page>
<div class="grid">
    <div class="col-12 md:col-8 m-auto my-5">
        <p-card header="Disclosure">
            <p *ngFor="let paragraph of disclosureContent; let i = index; trackBy: trackByIndex">
                {{ paragraph }}
            </p>
        </p-card>
    </div>
</div>
</app-page>